module.exports = __webpack_public_path__ + "static/media/16UNODC13.dcc96dc1.jpg";